<img *ngIf="(downloadUrl$ | async) as url; else noImage" [src]="url" class="media-object img-responsive" [style.max-height]="maxHeight"/>
<ng-template #noImage>
  <i class="glyphicon glyphicon-picture pull-right"
     title="{{ 'NO_LOGO_YET' | translate }}"
  ></i>
</ng-template>
